import isEmpty from 'lodash/isEmpty';
import sha1 from 'sha1';

import { bugsnag } from 'shared/utils/services/bugsnag';
import { retryTracker } from 'tracking/utils/retryTracker';

interface IFireImpactPageView {
  id?: number;
  email?: string;
}

interface IFireImpactConversion {
  orderNumber?: number;
  customerId?: number;
  customerEmail?: string;
  currencyCode?: string;
  subTotal?: number;
  category?: string;
  sku?: string;
  name?: string;
  customerStatus?: 'new' | 'returning';
}

const formatSubTotal = (price): string => {
  if (!price && price !== 0) return '';

  return (price / 100).toFixed(2);
};

export const fireImpactPageView = async ({ id, email = '' }: IFireImpactPageView) => {
  if (window?.ire) {
    try {
      await window.ire('identify', {
        customerId: id?.toString() || '',
        customerEmail: isEmpty(email) ? '' : sha1(email),
      });
    } catch (error) {
      const errorMessage = (error as Error).message;

      bugsnag(`Error firing impact page view: ${errorMessage}`, { context: 'impactEvents' });
    }
  }
};

export const fireImpactConversion = ({
  orderNumber,
  customerId,
  customerEmail = '',
  currencyCode = 'USD',
  subTotal,
  category = '',
  sku = '',
  name = '',
  customerStatus,
}: IFireImpactConversion) => {
  retryTracker({
    callbackFn: async () => {
      const conversionData = {
        orderId: `${orderNumber || ''}`,
        customerId: `${customerId || ''}`,
        customerEmail: isEmpty(customerEmail) ? '' : sha1(customerEmail),
        customerStatus,
        currencyCode,
        items: [
          {
            subTotal: formatSubTotal(subTotal),
            category,
            sku,
            quantity: 1,
            name,
          },
        ],
      };

      await window?.ire('trackConversion', 23087, conversionData);
    },
    context: 'fireImpactConversion',
    trackerKey: 'ire',
  });
};
